"use client";
import Link from "next/link";
import Image from "next/image";
import { FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import logo from "@/assets/img/logo/toshlima.jpg"; // adjust path

type Category = {
  id: string | number;
  name: string;
};

type FooterProps = {
  categories?: Category[];
};

const footerWidget = [
  {
    id: 1,
    title: "Quick Links",
    footer__links: [
      { list: "Privacy Policy", path: "/privacy-policy" },
      { list: "Terms & Condition", path: "/terms-and-conditions" },
      { list: "Returns & Refunds", path: "/returns-and-refunds" },
      { list: "Contact", path: "/contact" },
    ],
  },
  {
    id: 2,
    title: "Customer Services",
    footer__links: [
      { list: "Online Stores", path: "/shop" },
    ],
  },
];

const Footer = ({ categories = [] }: FooterProps) => {
  const iconStyle = { color: "#444", fontSize: "18px", marginRight: "12px", transition: "all 0.3s ease" };

  return (
    <footer
      style={{
        background: "linear-gradient(145deg, #f6f3ff 0%, #eae6ff 100%)",
        color: "#222",
        paddingTop: "90px",
        paddingBottom: "60px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Soft Glows */}
      <div
        style={{
          position: "absolute",
          top: "-60px",
          left: "-60px",
          width: "220px",
          height: "220px",
          background: "rgba(120,90,230,0.15)",
          borderRadius: "50%",
          filter: "blur(100px)",
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-80px",
          right: "-80px",
          width: "240px",
          height: "240px",
          background: "rgba(150,120,250,0.15)",
          borderRadius: "50%",
          filter: "blur(120px)",
          zIndex: 0,
        }}
      />

      <div
        className="container"
        style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px", position: "relative", zIndex: 2 }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "30px",
            justifyContent: "center",
          }}
        >
          {/* Business Info */}
          <div style={{ flex: "1 1 350px", minWidth: "300px" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: "25px",
                padding: "35px",
                boxShadow:
                  "16px 16px 40px rgba(120,90,230,0.25), -8px -8px 25px rgba(255,255,255,0.35), inset 3px 3px 6px rgba(255,255,255,0.45), inset -3px -3px 8px rgba(140,110,255,0.25)",
              }}
            >
              {/* Logo Image */}
             
             {/* Logo Image */}
<div style={{ marginBottom: "20px", display: "flex", justifyContent: "center" }}>
  <Image
    src={logo}
    alt="Tashlima Family Shop LLC"
    width={450} // increased from 220 to 300
    height={120} // increased from 60 to 80
    style={{ objectFit: "contain" }}
  />
</div>

              <div style={{ lineHeight: "1.8" }}>
                <h5 style={{ fontWeight: 700, marginBottom: "16px", fontSize: "18px", color: "#3c2b80" }}>
                  Contact Information
                </h5>

                <p style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "15px", color: "#222" }}>
                  <FaPhoneAlt color="#6b5bff" />
                  <a href="tel:+19293052812" style={{ color: "#222" }}>
                    +1 (929) 305-2812
                  </a>
                </p>

                <p style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "15px", color: "#222" }}>
                  <FaEnvelope color="#6b5bff" />
                  <a href="mailto:info@tashlimafamilyshop.org" style={{ color: "#222" }}>
                    info@tashlimafamilyshop.org
                  </a>
                </p>

                {/* Google Map */}
                <div
                  style={{
                    borderRadius: "16px",
                    overflow: "hidden",
                    marginTop: "20px",
                    boxShadow: "0 8px 25px rgba(107, 91, 255, 0.25)",
                  }}
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2948.209275525178!2d-73.75787672410785!3d42.65257962288573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89de0baf9c3f7b13%3A0x5b2cfbcde8236fdf!2s418%20Broadway%20STE%20N%2C%20Albany%2C%20NY%2012207%2C%20USA!5e0!3m2!1sen!2sus!4v1716482249468!5m2!1sen!2sus"
                    width="100%"
                    height="200"
                    style={{ border: "none" }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Links & Categories */}
          <div style={{ flex: "1 1 300px", minWidth: "280px", display: "flex", flexDirection: "column", gap: "30px" }}>
            {footerWidget.map((item) => (
              <div
                key={item.id}
                style={{
                  background: "#fff",
                  borderRadius: "25px",
                  padding: "35px",
                  boxShadow:
                    "16px 16px 40px rgba(120,90,230,0.25), -8px -8px 25px rgba(255,255,255,0.35), inset 3px 3px 6px rgba(255,255,255,0.45), inset -3px -3px 8px rgba(140,110,255,0.25)",
                }}
              >
                <h5 style={{ fontWeight: 700, marginBottom: "18px", fontSize: "18px", color: "#3c2b80" }}>
                  {item.title}
                </h5>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {item.footer__links.map((link, index) => (
                    <li key={index} style={{ marginBottom: "12px" }}>
                      <Link
                        href={link.path}
                        style={{
                          color: "#444",
                          fontSize: "15px",
                          fontWeight: 500,
                          textDecoration: "none",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = "#6b5bff")}
                        onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = "#444")}
                      >
                        {link.list}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            {/* Categories */}
            {categories.length > 0 && (
              <div
                style={{
                  background: "#fff",
                  borderRadius: "25px",
                  padding: "35px",
                  boxShadow:
                    "16px 16px 40px rgba(120,90,230,0.25), -8px -8px 25px rgba(255,255,255,0.35), inset 3px 3px 6px rgba(255,255,255,0.45), inset -3px -3px 8px rgba(140,110,255,0.25)",
                }}
              >
                <h5 style={{ fontWeight: 700, marginBottom: "18px", fontSize: "18px", color: "#3c2b80" }}>
                  Categories
                </h5>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {categories.map((cat) => (
                    <li key={cat.id} style={{ marginBottom: "12px" }}>
                      <Link
                        href={`/shop?category=${cat.id}`}
                        style={{
                          color: "#444",
                          fontSize: "15px",
                          fontWeight: 500,
                          textDecoration: "none",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = "#6b5bff")}
                        onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = "#444")}
                      >
                        {cat.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Social Media */}
            <div
              style={{
                background: "#fff",
                borderRadius: "25px",
                padding: "40px 25px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "20px",
                justifyContent: "center",
                boxShadow:
                  "16px 16px 50px rgba(120,90,230,0.25), -8px -8px 30px rgba(255,255,255,0.35), inset 3px 3px 8px rgba(255,255,255,0.15), inset -3px -3px 10px rgba(140,110,255,0.15)",
                transition: "all 0.3s ease",
              }}
            >
              <h5 style={{ fontWeight: 700, fontSize: "20px", color: "#3c2b80", marginBottom: "15px" }}>
                Follow Us On
              </h5>
              <div style={{ display: "flex", gap: "25px" }}>
                <Link href="#" style={{ transition: "all 0.3s ease" }}>
                  <FaFacebookF style={{ color: "#3b5998", fontSize: "28px" }} />
                </Link>
                <Link href="#" style={{ transition: "all 0.3s ease" }}>
                  <FaInstagram style={{ color: "#E1306C", fontSize: "28px" }} />
                </Link>
                <Link href="#" style={{ transition: "all 0.3s ease" }}>
                  <FaYoutube style={{ color: "#FF0000", fontSize: "28px" }} />
                </Link>
                <Link href="#" style={{ transition: "all 0.3s ease" }}>
                  <FaLinkedinIn style={{ color: "#0A66C2", fontSize: "28px" }} />
                </Link>
                <Link href="#" style={{ transition: "all 0.3s ease" }}>
                  <FaWhatsapp style={{ color: "#25D366", fontSize: "28px" }} />
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div
        style={{
          textAlign: "center",
          padding: "25px 20px",
          marginTop: "50px",
          fontSize: "14px",
          color: "#222",
        }}
      >
        <p>
          © {new Date().getFullYear()} <strong style={{ color: "#6b5bff" }}>Tashlima Family Shop LLC</strong> — All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
